<template>
   <div>
      <header class="prelogin-header">
         <div class="container">
            <div class="row">
               <div class="col-md-12">
                  <div class="header-logo">
                     <a href="/" title="OnBlick Inc.,">
                     <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/site-logo.svg`" class="site-header__menu-logo" alt="OnBlick Inc.,">
                     </a>
                  </div>
               </div>
            </div>
         </div>
      </header>
      <section class="container-register_body">
         <div class="">
            <div class="row">
               <div class="col-md-12">
                  <div class="page_heading">
                     <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/ess_employee.svg`" alt="OnBlick" />
                     <h1 class="text-uppercase">FORGOT PASSWORD</h1>
                     <p>Please enter your Email Address and we’ll send you a password reset link</p>
                  </div>
               </div>
            </div>
            <!-- Form -->
            <input type="hidden" id="CurrentTimeZone" name="CurrentTimeZone" />
            <input type="hidden" id="signIn" name="signIn" />
            <div class="row">
               <div class="col-md-12">
                  <div class="inputContainer_new">
                     <!-- <input type="text" @keyup.enter='ForgotPwd' id="Email" v-model.trim="email" @blur="blurEmail" name="email" value="" class="inputbox_input_new" :class="{ 'ob-vuelidate_input-error': $v.email.$error }" /> -->
                     <input type="text" id="Email" v-model.trim="email" @blur="blurEmail" name="email" value="" class="inputbox_input_new" :class="{ 'ob-vuelidate_input-error': $v.email.$error }" />
                     <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.required">Please enter email id</span>
                     <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.email">Please enter valid email</span>
                     <span class="ob-vuelidate_error-msg" v-if="$v.email.$dirty && !$v.email.maxLength">Please enter 150 characters only</span>
                     <label class="input_label_new" v-bind:class="{ moveTop : isActiveEmail }">Email Address</label>
                  </div>
                  <!-- <div class="inputContainer_new">
                     <input type="text" id="Email" name="email" value="" class="inputbox_input_new" />
                     <label class="input_label_new">Email Address</label>
                     </div> -->
               </div>
            </div>
            <div class="success_msg">
               <div class="row">
                  <div class="col-md-12">
                     <div class="msg" id="LoginMsg">
                        <div v-if="resMessage != '' && forgotPswdResponseState">
                           <p style="color: limegreen;">{{ resMessage }}</p>
                        </div>
                        <div v-else-if="resMessage != ''">
                           <p style="color: Crimson;">{{ resMessage }}</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row">
               <div class="col-md-12">
                  <div class="create_account text-align-center">
                     <!-- <button type="submit" @click="ForgotPwd" class="btn--prelogin btn--prelogin_min forgotpassword_validation" id="pwdSubmit" value="">Submit</button> -->
                     <button type="submit" class="btn--prelogin btn--prelogin_min forgotpassword_validation" id="pwdSubmit" value="">Submit</button>
                  </div>
               </div>
            </div>
            <!-- Form Ending-->
         </div>
      </section>
      <footer class="footer">
         <div class="copyright text-center"> &copy; {{date}} OnBlick Inc., All rights reserved </div>
      </footer>
      <!-- cookies are disabled -->
      <div class="modal fade" id="CookiesDisabled" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
         <div class="modal-dialog CookiesDisabled" role="document">
            <div class="modal-content">
               <div class="modal-header">
                  <div class="modal-cookie-logo">
                     <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/src/assets/Images/site-logo.svg`" class="site-header__menu-logo" alt="OnBlick Inc.,">
                  </div>
               </div>
               <div class="modal-body">
                  <h4 class="modal-title modal-cookie-title">
                     <b>Enable Cookies</b>
                  </h4>
                  <p>Your browser has cookies disabled, please enable them and try again</p>
               </div>
               <div class="modal-footer align-center">
                  <button type="button" class="btn btn-primary" data-dismiss="modal">Ok</button>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>
<script>
   import { required, minLength, alph, email, numeric, url, maxLength } from 'vuelidate/lib/validators'
   export default {
     name: "ForgotPassword",
     data() {
         return {
               email:'',
               isActiveEmail:'',
               date : new Date().getFullYear(),
               resMessage: '',
               forgotPswdResponseState: false
         }
     },
      created() {
         this.$v.email.$reset();
         },
   
         validations(){
               return {
   
                     "email" :{
                           required,
                           email,
                           maxLength: maxLength(150)
                     },
               }
         },
         methods:{
               ForgotPwd(){
                     this.$v.email.$touch()
                     if (this.$v.email.$invalid == false) {
                           this.$loading({ 'loadingText': 'Loading...' })
                           ajax.get(`/Employee/ESSForgotPassword?email=` + this.email.toLowerCase(), {}, (res) => {
                                 this.$loading({}).close()
                                 if(res.data.State == true){
                                       this.forgotPswdResponseState = res.data.State
                                 }
                                 this.resMessage = res.data.Message
                           })
   
                     }
               },
               blurEmail(){
                    this.$v.email.$touch()
                    if(this.email != ''){
                        this.isActiveEmail=true
                    }
                    else{
                          this.isActiveEmail=false
                    }
               }
         }
   };
</script>
<style lang="scss">
   @import '../../static/Css/Content/SCSS/post-login-scss/scss/login.scss';
   .container-register_body .ob-vuelidate_error-msg{
   position: absolute;
   top: 18px;
   right: 15px;
   font-size: 12px;
   color: #cc2550;
   }
</style>


// WEBPACK FOOTER //
// src/components/ForgotPassword.vue